module.exports = __webpack_public_path__ + "static/media/operational_icon.ceb99df9.png";